import { Base } from '@studiometa/js-toolkit';
import { Frame } from '@studiometa/ui';

/**
 * Blog component
 */
export default class Blog extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Blog',
    components: {
      Frame,
    },
  };

  /**
   * Scroll to top of page when pagination triggers a Frame fetch.
   */
  onFrameFrameFetchAfter() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
